const SESSION_STORAGE_KEY = {
  SESSION_START_TIME: "SESSION_START_TIME",
  PAGE_VISIT_COUNT: "PAGE_VISIT_COUNT",
};

const EXCLUDED_ROUTES_FOR_ANALYTICS = ["/admin"];

const API_SLOW_THRESHOLD = 2000;

const CART_ABANDON_REASON = {
  INACTIVITY: "inactivity",
  CART_CLOSED: "cart_closed",
  PAYMENT_FAILED: "payment_failed",
  PAYMENT_CANCELLED: "payment_cancelled",
  CART_CHANGED: "cart_changed",
  NAVIGATED_AWAY: "navigated_away",
};

const CART_INACTIVITY_TIMEOUT = 60000;

export {
  SESSION_STORAGE_KEY,
  EXCLUDED_ROUTES_FOR_ANALYTICS,
  API_SLOW_THRESHOLD,
  CART_ABANDON_REASON,
  CART_INACTIVITY_TIMEOUT,
};
